import TrainsFiltersBaseController from '../../trains-base/controllers/trains-filters-base-controller';

export default function TrainsFiltersController(
    $scope,
    $controller,
    trainsFactory
) {
    'ngInject';

    $controller(TrainsFiltersBaseController, {
        $scope,
        trainsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-filters-controller.js